export default {"src":"/_next/static/media/gallery.0362f2bf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};